export class UploadShotsData {
  public OrderId: number;
  public ImagePaths: ImagePath[];

  constructor(init?: Partial<UploadShotsData>) {
    Object.assign(this, init);
  }
}

export class ImagePath {
  public ImgPath: string;
  public FileName: string;
  constructor(imgPath: string, name: string) {
    this.ImgPath = imgPath;
    this.FileName = name;
  }
}
